import { type Airror, isAirror } from '@air/errors';

// biome-ignore lint/suspicious/noExplicitAny: <https://linear.app/air/issue/ENG-136/update-isairrorinstance-to-not-use-any>
export const isAirrorInstance = (result: any): result is Airror<any, any> => isAirror(result);
